(() => {
  const initializeFooter = (scope = document) => {
    scope.querySelectorAll('[data-marmelade-footer]').forEach((footer) => {
      if (footer.dataset.footerInteractive === 'true') return;
      footer.dataset.footerInteractive = 'true';

      const disclosures = [...footer.querySelectorAll('[data-footer-disclosure]')];
      const language = footer.querySelector('[data-footer-language]');
      const desktopDisclosures = window.matchMedia('(min-width: 768px)');

      const setExpanded = (detail, shouldOpen) => {
        const summary = detail.querySelector(':scope > summary');
        const panel = detail.querySelector('[data-footer-panel], [data-footer-language-panel]');
        if (!summary || !panel) return;

        panel.getAnimations().forEach((animation) => animation.cancel());
        const startHeight = panel.getBoundingClientRect().height;
        const isLanguage = panel.hasAttribute('data-footer-language-panel');

        if (shouldOpen) detail.open = true;

        const endHeight = shouldOpen ? panel.scrollHeight : 0;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        summary.setAttribute('aria-expanded', String(shouldOpen));

        const startFrame = isLanguage ? {} : { height: `${startHeight}px` };
        const endFrame = isLanguage ? {} : { height: `${endHeight}px` };

        if (isLanguage) {
          startFrame.opacity = shouldOpen ? 0 : 1;
          startFrame.transform = shouldOpen ? 'translateY(8px)' : 'translateY(0)';
          endFrame.opacity = shouldOpen ? 1 : 0;
          endFrame.transform = shouldOpen ? 'translateY(0)' : 'translateY(8px)';
        }

        const animation = panel.animate([startFrame, endFrame], {
          duration: reduceMotion ? 0 : 250,
          easing: 'ease',
        });

        animation.addEventListener('finish', () => {
          detail.open = shouldOpen;
          panel.style.height = isLanguage || shouldOpen ? 'auto' : '0px';
          if (isLanguage) {
            panel.style.opacity = shouldOpen ? '1' : '0';
            panel.style.transform = shouldOpen ? 'translateY(0)' : 'translateY(8px)';
          }
        }, { once: true });
      };

      disclosures.forEach((detail) => {
        const summary = detail.querySelector(':scope > summary');
        const panel = detail.querySelector('[data-footer-panel]');
        if (!summary || !panel) return;

        panel.style.height = detail.open ? 'auto' : '0px';
        summary.setAttribute('aria-expanded', String(detail.open));
        summary.addEventListener('click', (event) => {
          event.preventDefault();
          if (desktopDisclosures.matches) return;
          const shouldOpen = summary.getAttribute('aria-expanded') !== 'true';

          if (shouldOpen) {
            disclosures.forEach((item) => {
              if (item !== detail && item.querySelector(':scope > summary')?.getAttribute('aria-expanded') === 'true') {
                setExpanded(item, false);
              }
            });
            if (language?.querySelector(':scope > summary')?.getAttribute('aria-expanded') === 'true') {
              setExpanded(language, false);
            }
          }

          setExpanded(detail, shouldOpen);
        });
      });

      const syncDisclosureMode = () => {
        disclosures.forEach((detail) => {
          const summary = detail.querySelector(':scope > summary');
          const panel = detail.querySelector('[data-footer-panel]');
          if (!summary || !panel) return;

          panel.getAnimations().forEach((animation) => animation.cancel());
          detail.open = desktopDisclosures.matches;
          summary.setAttribute('aria-expanded', String(desktopDisclosures.matches));
          panel.style.height = desktopDisclosures.matches ? 'auto' : '0px';
        });
      };

      syncDisclosureMode();
      desktopDisclosures.addEventListener('change', syncDisclosureMode);

      if (language) {
        const summary = language.querySelector(':scope > summary');
        const panel = language.querySelector('[data-footer-language-panel]');

        if (summary && panel) {
          const languageLinks = [...panel.querySelectorAll('[data-footer-language-link]')];
          panel.style.height = 'auto';
          panel.style.opacity = '0';
          panel.style.transform = 'translateY(8px)';
          summary.setAttribute('aria-expanded', 'false');

          summary.addEventListener('click', (event) => {
            event.preventDefault();
            const shouldOpen = summary.getAttribute('aria-expanded') !== 'true';

            setExpanded(language, shouldOpen);
          });

          document.addEventListener('click', (event) => {
            if (!footer.isConnected || language.contains(event.target)) return;
            if (summary.getAttribute('aria-expanded') === 'true') setExpanded(language, false);
          });

          document.addEventListener('keydown', (event) => {
            if (!footer.isConnected || event.key !== 'Escape') return;
            if (summary.getAttribute('aria-expanded') === 'true') {
              setExpanded(language, false);
              summary.focus();
            }
          });

          languageLinks.forEach((link) => {
            link.addEventListener('click', (event) => {
              if (link.getAttribute('aria-current') === 'page') {
                event.preventDefault();
                setExpanded(language, false);
                return;
              }

              event.preventDefault();
              const destination = new URL(link.href, window.location.origin);
              destination.search = window.location.search;
              destination.hash = window.location.hash;
              window.location.assign(destination.href);
            });
          });
        }
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeFooter(), { once: true });
  } else {
    initializeFooter();
  }

  document.addEventListener('shopify:section:load', (event) => initializeFooter(event.target));
})();
